import * as React from 'react';
import { connect } from 'react-redux';
import { ReduxState } from 'kb-shared';

/**
 * Conditionally routes user between two components based on feature flag.
 * Use the HOC below for a simple way to configure feature flag's that switch between components.
 */
type Props = {
  allFeatures: {
    [key: string]: boolean;
  };
  featureFlagKey: string;
  featureComponent: React.ComponentType<unknown>;
  defaultComponent: React.ComponentType<unknown>;
};

// Be sure to spread props below into components to carry over navigation etc
class FeatureFlagRouter extends React.Component<Props> {
  render() {
    const featureEnabled = this.props.allFeatures[this.props.featureFlagKey];
    const FFComponent = this.props.featureComponent;
    const DefaultComponent = this.props.defaultComponent;
    if (featureEnabled) {
      return <FFComponent {...this.props} />;
    } else {
      return <DefaultComponent {...this.props} />;
    }
  }
}

const mapStateToProps = (state: ReduxState) => {
  const allFeatures = state.features.features;
  return {
    allFeatures
  };
};

// @ts-ignore
const ConnectedFeatureFlagRouter = connect(mapStateToProps)(FeatureFlagRouter);

export function withFFRouter(
  defaultComponent: React.ComponentType<any>,
  featureComponent: React.ComponentType<any>,
  flag: string
) {
  // @ts-ignore
  const ConnectedRouter = (restProps: unknown) => {
    return (
      <ConnectedFeatureFlagRouter
        defaultComponent={defaultComponent}
        featureComponent={featureComponent}
        featureFlagKey={flag}
        {...restProps}
      />
    );
  };

  return ConnectedRouter;
}
